<template>
  <el-row class="card">
    <el-form :model="value" :rules="rules" ref="financialAsset" class="financialAsset">
      <div class="card-header">
        <el-row :gutter="20">
          <el-col :span="4">
            <strong>Asset Name</strong>
          </el-col>
          <el-col :span="4">
            <strong>Cash value paid in period</strong>
           </el-col>
          <el-col :span="2">
            <tool-tip-popup :text="expendToolTipText" :showLink="true"></tool-tip-popup>
          </el-col>
          <el-col :span="14">
            <el-col :span="6">
              <strong>Check if included in  the Annual Expense Plan and Capital Plan.</strong>
            </el-col>
            <div v-if="showDepreciation">
              <el-col :span="8">
                <strong>Classification</strong>
              </el-col>
              <el-col :span="6">
                <strong>{{depreciationText}}</strong>
              </el-col>
              <div v-if="showHelp">
                <el-col :span="1">
                  <tool-tip-link-popup  toolLink="https://home.teleflex.com/Intranet/TeleflexIncorporated/departments/Finance/policies/PEAProcedure.html#AssetCategories" linkLabel="Teleflex Depreciation Info"></tool-tip-link-popup>
                </el-col>
              </div>
              </div>
            <div v-if="!showDepreciation">
              <el-col :span="18">
                <strong>Classification</strong>
              </el-col>
              <el-col :span="2">
              </el-col>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="card-block">
        <el-row :gutter="20">
          <el-col :span="4">
            <el-form-item prop="name">
              <el-input type="textarea" :disabled="disabled" v-model="value.name" :minlength="3" :maxlength="50" :autosize="{ minRows: 1, maxRows: 2}"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-row :gutter="20">
              <el-col :span="16">
                <el-form-item prop="yearOneAmount">
                  <currency-input :change="updateForClassificationChange" :disabled="disabled" v-model="value.yearOneAmount" ></currency-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <div class="paidIn">
                  <strong>Paid In {{startingYear}}</strong>
                </div>
              </el-col>
            </el-row>
            <br>
            <el-row :gutter="20">
              <el-col :span="16">
                <el-form-item prop="yearTwoAmount">
                  <currency-input :change="updateForClassificationChange" :disabled="disabled" v-model="value.yearTwoAmount"></currency-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <div class="paidIn">
                  <strong>Paid In {{startingYear + 1}}</strong>
                </div>
              </el-col>
            </el-row>
            <br>
            <el-row :gutter="20">
              <el-col :span="16">
                <el-form-item prop="yearThreeAmount">
                  <currency-input :change="updateForClassificationChange" :disabled="disabled" v-model="value.yearThreeAmount"></currency-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <div class="paidIn">
                  <strong>Paid In {{startingYear + 2}}</strong>
                </div>
              </el-col>
            </el-row>
            <br>
            <el-row :gutter="20">
              <el-col :span="16">
                <el-form-item prop="yearFourAmount">
                  <currency-input :change="updateForClassificationChange" :disabled="disabled" v-model="value.yearFourAmount"></currency-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <div class="paidIn">
                  <strong>Paid In {{startingYear + 3}}+</strong>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="14">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item prop="inProfitPlan">
                  <el-checkbox :disabled="disabled" v-model="value.inProfitPlan" style="margin-left: 10%;" />
                </el-form-item>
              </el-col>
              <div v-if="showDepreciation">
                <el-col :span="8">
                  <el-form-item prop="classificationId">
                    <asset-classification :disabled="disabled" v-model="value.classificationId" @change="updateForClassificationChange"></asset-classification>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item prop="depreciation">
                    <el-input type="number" :disabled="disabled" v-model="value.depreciation"></el-input>
                  </el-form-item>
                </el-col>
              </div>
              <div v-if="!showDepreciation">
                <el-col :span="18">
                  <el-form-item prop="classificationId">
                    <asset-classification :disabled="disabled" v-model="value.classificationId" @change="updateForClassificationChange"></asset-classification>
                  </el-form-item>
                </el-col>
              </div>
            </el-row>
            <el-row>
              <el-col :lg="6">
                <br>
              </el-col>
              <el-col v-if="value.classificationId === 2" :lg="14" style="margin-left: 10px;">
                <el-form-item prop="cloudComputing" required>
                  <el-col style="line-height: 20px; font-size: 14px;" :lg="10">
                    <p style="margin-top: 25px;"><strong><span style="color: #F56C6C;">*</span> Does this PEA have a Cloud Computing Arrangement (CCA)?</strong></p>
                  </el-col>
                  <el-col :lg="3">
                    <el-radio-group :disabled="disabled" style="margin-top: 25px;" v-model="value.cloudComputing">
                      <el-radio :label="true">Yes</el-radio>
                      <el-radio :label="false">No</el-radio>
                    </el-radio-group>
                  </el-col>
                  <el-col :lg="3" style="margin-top: 25px;">
                    <tool-tip-popup text="Software products that have traditionally been installed locally on a customer’s server are now often hosted on a vendor’s server and accessed by the customer remotely. These arrangements are sometimes referred to as cloud computing arrangements (CCAs). Please indicate yes if this arrangement is a part of this Software Asset."></tool-tip-popup>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :lg="4">
                <br>
              </el-col>
            </el-row>
            <br/>
            <el-row :gutter="20">
              <el-col :span="24">
                <strong> Description: </strong>
                <el-form-item prop="description">
                  <el-input :disabled="disabled" type="textarea" v-model="value.description" style="margin-top:4px;" :minlength="3" :maxlength="150" :autosize="{ minRows: 1, maxRows: 3}"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <div class="card-footer">
        <el-row :gutter="20">
          <el-col :span="24">
            <strong>Asset TOTAL: $ {{ callFormatMoney(value.totalAmount) }}</strong>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </el-row>
</template>
<script>
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  name: 'financial-asset',
  props: {
    'value': {
      type: Object,
      required: true
    },
    peaId: {
      default: 0
    },
    showDepreciation: {
      default: true
    },
    showHelp: {
      default: false
    },
    depreciationText: {
      default: 'Depreciation Life (Years)'
    },
    disabled: {
      default: false
    },
    startingYear: {
      default: new Date().getFullYear()
    }
  },
  data () {
    var validateMoneySize = (rule, value, callback) => {
      if (value >= 99999999999.99) {
        callback(new Error('Must be less than $99,999,999,999.99'))
      }
      callback()
    }
    var validateDepreciationSize = (rule, value, callback) => {
      if (value >= 999) {
        callback(new Error('Must be less than 999'))
      }
      callback()
    }
    var validateDepreciationType = (rule, value, callback) => {
      if (!Number.isInteger(parseFloat(value))) {
        callback(new Error('Must be an integer'))
      }
      callback()
    }
    var validateCloudComputing = (rule, value, callback) => {
      if (this.value.classificationId === 2) {
        if (value === null) {
          callback(new Error('Please select an option for CCA'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      expendToolTipText: 'Enter the cash value paid per year for each of the first 3 years.  Any amount after the first 3 years should be combined in the fourth bucket',
      rules: {
        cloudComputing: [
          { validator: validateCloudComputing, trigger: 'change' }
        ],
        name: [
          { required: true, message: 'Please input name', trigger: 'blur' },
          { min: 3, max: 160, message: 'Length should be 3 to 160 characters', trigger: 'blur' }
        ],
        description: [
          { required: true, message: 'Please input description', trigger: 'blur' },
          { min: 3, max: 6500, message: 'Length should be 3 to 6500 characters', trigger: 'blur' }
        ],
        classificationId: [
          { type: 'number', required: true, message: 'Please pick classification', trigger: 'visible-change' }
        ],
        depreciation: [
          { required: true, message: 'Please input years', trigger: 'blur' },
          { validator: validateDepreciationSize, trigger: 'blur' },
          { validator: validateDepreciationType, trigger: 'blur' }
        ],
        yearOneAmount: [
          { required: true, message: 'Please input amount', trigger: 'blur' },
          { validator: validateMoneySize, trigger: 'blur' }
        ],
        yearTwoAmount: [
          { required: true, message: 'Please input amount', trigger: 'blur' },
          { validator: validateMoneySize, trigger: 'blur' }
        ],
        yearThreeAmount: [
          { required: true, message: 'Please input amount', trigger: 'blur' },
          { validator: validateMoneySize, trigger: 'blur' }
        ],
        yearFourAmount: [
          { required: true, message: 'Please input amount', trigger: 'blur' },
          { validator: validateMoneySize, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    updateForClassificationChange () {
      this.$emit('classificationChange')
    },
    updateTotal () {
      this.value.totalAmount = ((this.value.yearOneAmount === null) ? 0 : this.value.yearOneAmount) +
        ((this.value.yearTwoAmount === null) ? 0 : this.value.yearTwoAmount) +
        ((this.value.yearThreeAmount === null) ? 0 : this.value.yearThreeAmount) +
        ((this.value.yearFourAmount === null) ? 0 : this.value.yearFourAmount)
    },
    updateCloudComputing (newVal, oldVal) {
      this.$emit('cloudComputingChange', newVal)
    },
    checkAssetValid () {
      if (this.value.removeAsset) {
        this.$emit('financialAssetValidation', true)
      } else {
        this.$refs['financialAsset'].validate((valid) => {
          if (valid) {
            this.$emit('financialAssetValidation', true)
          } else {
            this.$emit('financialAssetValidation', false)
          }
        })
      }
    },
    callFormatMoney (money) {
      return helperMethods.formatMoney(money)
    }
  },
  watch: {
    'value.classificationId': function (newVal, oldVal) {
      if (newVal !== 2) {
        this.value.cloudComputing = null
      }
      this.updateForClassificationChange()
    },
    'value.yearOneAmount': 'updateTotal',
    'value.yearTwoAmount': 'updateTotal',
    'value.yearThreeAmount': 'updateTotal',
    'value.yearFourAmount': 'updateTotal',
    'value.cloudComputing': 'updateCloudComputing'
  }
}
</script>

<style scoped>

.paidIn {
  font-size: 14px;
}
.financialAsset .currency-input {
  max-width: 170px;
  float: left;
  margin-right: 10px;
}
</style>
